import { AccountType } from '@/common/types'
import { ONBOARDING_COPY } from '@/locales/en'

export function KycRequirements({
    frankieOneOnboarding,
    accountType,
    title = ONBOARDING_COPY.kycInit.points.title,
    subtitle,
    textClassName,
}: {
    frankieOneOnboarding: boolean
    accountType: AccountType
    title?: string
    subtitle?: string
    textClassName?: string
}) {
    const serviceAccountType = frankieOneOnboarding ? 'frankieOneIndividual' : accountType

    return (
        <>
            <div className="flex flex-col items-start gap-6 w-full">
                <div className="flex flex-col gap-4 w-full">
                    <div className={`flex flex-col items-start gap-1.5 ${textClassName}`}>
                        <span className="font-medium leading-[22px] font-['Inter']">{title}</span>
                        {subtitle && <span className="font-normal leading-[22px]">{subtitle}</span>}
                    </div>
                    <ul className="mt-2 w-full">
                        {ONBOARDING_COPY.kycInit.points[serviceAccountType].map((item, index) => (
                            <li key={index} className="flex flex-row items-center gap-4 leading-[22px] mb-4 lh-140">
                                <svg
                                    className="w-6 h-6 flex-shrink-0"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
                                        fill="#137157"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path d="M9 12L11 14L15 10" fill="#137157" />
                                    <path
                                        d="M9 12L11 14L15 10"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    )
}
